
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 39.777 30.021"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Group 728","fill":"none"}},[_c('path',{attrs:{"data-name":"Path 6792","d":"M15.348.741v16.8c0 5.295-3.522 11.691-3.522 11.691H.56s12.6-8.559 12.6-16.362L13.003.738z"}}),_c('path',{attrs:{"data-name":"Path 6793","d":"M5.668 29.234a39.143 39.143 0 006.946-9.844"}}),_c('path',{attrs:{"data-name":"Path 6794","d":"M13.001.741l-2.363 1.138v17.679"}}),_c('path',{attrs:{"data-name":"Path 6795","d":"M10.638 1.879H7.513V23.31"}}),_c('path',{attrs:{"data-name":"Path 6796","d":"M24.427 18.103a8.975 8.975 0 00-4.54-7.715 8.977 8.977 0 00-4.54 7.715"}}),_c('path',{attrs:{"data-name":"Path 6797","d":"M24.428.741v16.8c0 5.295 3.522 11.691 3.522 11.691h11.271s-12.6-8.559-12.6-16.362L26.777.738z"}}),_c('path',{attrs:{"data-name":"Path 6798","d":"M34.104 29.234a39.16 39.16 0 01-6.947-9.844"}}),_c('path',{attrs:{"data-name":"Path 6799","d":"M26.776.741l2.363 1.138v17.679"}}),_c('path',{attrs:{"data-name":"Path 6800","d":"M29.139 1.879h3.121V23.31"}}),_c('path',{attrs:{"data-name":"Line 31","d":"M15.349 2.414h9.079"}}),_c('path',{attrs:{"data-name":"Path 6801","d":"M21.891 8.118a3.96 3.96 0 00-2-3.4 3.959 3.959 0 00-2 3.4z"}})])])
          )
        }
      }
    